export default __webpack_public_path__ + "static/media/img_7.3d6a9a76.jpg";